import { useSkipConfirm } from "./use-skip-confirm";

/**
 * Composable for handling item removal with optional confirmation dialog.
 *
 * @param {Object} options
 * @param {string} options.cookieName - Name of the cookie to track "don't ask again" preference
 * @param {Function} options.remove - Function that removes the item and returns the removed index
 * @param {Function} options.triggerSave - Function to trigger save after removal
 * @param {Function} options.onRemoved - Callback with removed index after successful removal
 * @returns {Object} - showDeleteConfirm ref, handleRemove function, setSkipDeleteConfirm function
 */
export function useItemRemove({ cookieName, remove, triggerSave, onRemoved }) {
  const {
    showConfirm: showDeleteConfirm,
    maybeConfirm,
    setSkipForever: setSkipDeleteConfirm,
  } = useSkipConfirm(cookieName);

  function handleRemove() {
    maybeConfirm(doRemove);
  }

  async function doRemove() {
    const removedIndex = await remove();
    if (removedIndex !== undefined) {
      await triggerSave?.();
      onRemoved?.(removedIndex);
    }
  }

  return {
    showDeleteConfirm,
    handleRemove,
    doRemove,
    setSkipDeleteConfirm,
  };
}
